import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import {
  userInfoPLACEHOLDER,
  UserReducer,
  userSettingsPLACEHOLDER,
} from "./types";
import {
  setIsLoading,
  setStateChangedInfo,
  setStateChangedSettings,
  setUserInfo,
  setUserSettings,
  updateUserInfo,
  updateUserSettings,
} from "./actionCreators";

import informationReducer from "./subreducers/informationReducer";
import settingsReducer from "./subreducers/settingsReducer";

const initialState: UserReducer = {
  settings: userSettingsPLACEHOLDER,
  information: userInfoPLACEHOLDER,
  isLoading: false,
};

const userReducer = reducer(
  initialState,
  on(
    ...union(setUserInfo, updateUserInfo, setStateChangedInfo),
    (state, action) => {
      state.information = informationReducer(state.information, action);
    }
  ),
  on(
    ...union(setUserSettings, updateUserSettings, setStateChangedSettings),
    (state, action) => {
      state.settings = settingsReducer(state.settings, action);
    }
  ),
  on(setIsLoading, (state, { payload: { isLoading } }) => {
    state.isLoading = isLoading;
  })
);

export default userReducer;
